import jwtDefaultConfig from './jwtDefaultConfig'
import router from '@/router'
import { FrontendApi, Configuration } from "@ory/client";


export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  /**
   * @type {FrontendApi}
   */
  ory = null;

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    this.ory = new FrontendApi(
        new Configuration({
          basePath: process.env.VUE_APP_ORY_URL,
          baseOptions: {
            withCredentials: true,
          }
        })
    );

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        config.withCredentials = true;
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {
        if (response && response.status === 401) {
          if (originalRequest.url.includes('/agreements/user')) {
            return Promise.reject(error)
          }
          if (originalRequest.url.includes('/users/me')) {
            return Promise.reject(error)
          }
          if (this.getLogoutUrl()) {
            axiosIns.get(this.getLogoutUrl()).finally(() => {
              this.refreshToken()
            });
          } else {
            this.refreshToken()
          }

          return Promise.reject(error)
        }
        return Promise.reject(error)
      },
    )
  }



  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  async loadUserData() {
    try {
      const session = await this.getOrySession();
      if (session == null) {
        throw new Error('Error getting session');
      }
      const response = await this.axiosIns.get(this.jwtConfig.userDataEndpoint);
      if (response.status !== 200) {
        throw new Error('Error getting user data');
      }

      const res = response.data.results[0];
      localStorage.setItem(this.jwtConfig.storageLogoutUrlKeyName, session.logoutUrl);
      localStorage.setItem(this.jwtConfig.storageUserDataKeyName, JSON.stringify(res));
      return res;

    } catch (err) {
      console.log(err)
      this.clearUserData();
      if (err.response && err.response.status === 401 && err.response.request.responseURL.includes('/users/me')) {
        await router.push({
          name: 'error-msg',
          params: {
            error: `User not found`,
            message: `Your user was not found in DWG. Please contact the administrator.`
          }
        })
      }
      return null;
    }
  }

  async updateUserData() {
    const response = await this.axiosIns.get(this.jwtConfig.userDataEndpoint);
    if (response.status !== 200) {
      throw new Error('Error getting user data');
    }
    const res = response.data.results[0];
    localStorage.setItem(this.jwtConfig.storageUserDataKeyName, JSON.stringify(res));
  }

  getUserData() {
    return JSON.parse(localStorage.getItem(this.jwtConfig.storageUserDataKeyName))
  }

  getLogoutUrl() {
    return localStorage.getItem(this.jwtConfig.storageLogoutUrlKeyName)
  }

  clearUserData() {
    localStorage.removeItem(this.jwtConfig.storageUserDataKeyName);
    localStorage.removeItem(this.jwtConfig.storageLogoutUrlKeyName);
  }

  async getOrySession() {
    try {
      const sessionRes = await this.ory.toSession();
      const logoutUrlRes = await this.ory.createBrowserLogoutFlow({returnTo: `${window.location.origin}/logout`});
      sessionRes.data['logoutUrl'] = `${logoutUrlRes.data.logout_url}`;
      return sessionRes.data;
    } catch (e) {
      console.error('ORY ERROR');
      console.error(e);
      return null;
    }
  }

  refreshToken() {
    router.push({ name: 'login', query: { redirectFrom: router.currentRoute.fullPath } })
  }
}
